import { ICON__flame } from '@/assets/icons_fa';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { EKeyCode } from '@/enums/e_key_code';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { Key } from '@/enums/key';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { set_timeout } from '@/utils/utils_client';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BUTTON__navigation_desktop } from '../desktop/BUTTON__navigation_desktop';
import { ButtonNavigationMobile } from '../mobile/ButtonNavigationMobile';
import { PROPS__button_navigation } from './PROPS__button_navigation';

export function BUTTON__navigation_generation() {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { global_is_mobile, global_need_show_first_animation, global__page_type } = use_slice_ui([
    'global_is_mobile',
    'global_need_show_first_animation',
    'global__page_type',
  ]);
  const { generation_current } = use_slice_generation(['generation_current']);

  const [is_visible, set_is_visible] = useState(true);

  const [is_animation_enabled, set_is_animation_enabled] = useState(false);

  const [generation_previous, set_generation_previous] = useState(generation_current);

  const shortcut_key = Key.W;
  const shortcut_key_codes = [EKeyCode.W];

  /*
   * EFFECTS
   */
  use_effect(() => set_is_visible(!generation_current.is_stub()), [generation_current]);

  use_effect(() => {
    if (global__page_type == ENUM__page_type.GENERATION) return;
    if (global__page_type == ENUM__page_type.GENERATION_WITHOUT_PARAMS) return;
    if (generation_current._id === generation_previous._id) return; //generation is not changed
    if (generation_current.workspace_id != generation_previous.workspace_id) return set_generation_previous(generation_current); //workspace changed

    set_generation_previous(generation_current);

    if (generation_current.is_stub()) return;

    set_is_animation_enabled(true);

    const timeout_id = set_timeout(() => set_is_animation_enabled(false), CONSTANTS_TIME__client.TIMEOUT_DURATION_ANIMATION_BUTTON_NAVIGATION_GENERATION);

    return () => clearTimeout(timeout_id);
  }, [generation_current._id]);

  let props: PROPS__button_navigation = {
    global_need_show_first_animation,
    page_type: ENUM__page_type.GENERATION_WITHOUT_PARAMS,
    tooltip_title: t(i18n_base_ui.sidebar_navigation.tabs.generation.tooltip.title, { shortcut_key: shortcut_key.toUpperCase() }),
    title: t(i18n_base_ui.sidebar_navigation.tabs.generation.title),
    Icon: ICON__flame,
    is_animation_enabled,
  };

  /*
   * HTML
   */

  if (!is_visible) return null;

  return global_is_mobile ? <ButtonNavigationMobile {...props} /> : <BUTTON__navigation_desktop {...props} {...{ shortcut_key_codes }} />;
}
